import axios from 'axios';
const http = axios.create({ baseURL: import.meta.env.VITE_BASE_API_URL, timeout: 30000 });
const root = slug => `/schedule/public/${encodeURIComponent(slug)}/packages`;
export const getCatalog = (slug, signal) => http.get(root(slug), { signal }).then(r => r.data);
export const getSlots = (slug, params, signal) => http.get(`${root(slug)}/slots`, { params, signal }).then(r => r.data.slots);
export const identify = (slug, data) => http.post(`${root(slug)}/identity`, data).then(r => r.data);
export const book = (slug, data) => http.post(`${root(slug)}/book`, data).then(r => r.data);
export const cancel = (slug, id, data) => http.post(`${root(slug)}/requests/${encodeURIComponent(id)}/cancel`, data);
